import { Box, Paper, Typography, TextField, Button } from "@mui/material";
import { ForgetPasswordScheema } from "../schema/schema";
import { useFormik } from "formik";
import color from "../utils/Colors";
import { forgotPassword } from "../../services/services";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../utils/SnackBar";

function ForgetPassword() {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ForgetPasswordScheema,
    onSubmit: (values) => {
      forgotPassword(values)
        .then((result: any) => {
          if (result?.data?.statusCode === 200) {
            showSnackbar("Reset email sent!");
            navigate("/auth");
          }
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message ||
              error?.response?.data?.msg ||
              "Failed to send email",
          );
        });
    },
  });
  return (
    <div>
      {" "}
      <Box
        sx={{
          width: "100%",
          px: { xs: 2, sm: 0 },
          border: "2px solid",
          borderColor: color.borderColor,
          borderRadius: "18px",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: { xs: 2, sm: 6 },
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: { xs: "40px", sm: "70px" },
            paddingBottom: { xs: "40px", sm: "70px" },
            zIndex: 100,
          }}
        >
          <Typography
            variant="h5"
            align="center"
            sx={{
              color: "#321548",
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: "18px", sm: "20px", md: "22px" },
            }}
          >
            Forget your Password ?
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            sx={{
              color: "#746283",
              fontWeight: 400,
              mb: 4,
              fontSize: { xs: "9px", sm: "11px", md: "13px" },
            }}
          >
            We will send you an email to reset your password
          </Typography>
          <Box component="form" onSubmit={formik.handleSubmit}>
            <TextField
              placeholder="email"
              className="input-root2"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              variant="outlined"
              fullWidth
              InputLabelProps={{ sx: { fontSize: "12px" } }}
              sx={{
                mb: 3,
                background: "white",
                borderRadius: 3,
                "& .MuiOutlinedInput-root": { borderRadius: 3 },
              }}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#35185A",
                borderRadius: 3,
                textTransform: "none",
              }}
              type="submit"
              disabled={!(formik.isValid && formik.dirty)}
            >
              Send
            </Button>
          </Box>
        </Paper>
      </Box>
    </div>
  );
}

export default ForgetPassword;
